import { useState, useEffect } from 'react';
import api from '../services/api';

export default function useInterimAlerts() {
  const [interimOverdueData, setInterimOverdueData] = useState(null);
  const [interimOverdueLoading, setInterimOverdueLoading] = useState(true);

  useEffect(() => {
    const fetchInterimOverdueData = async () => {
      try {
        setInterimOverdueLoading(true);
        const response = await api.get('/interim-birth-notification/overdue/', {
          params: { page_size: 5 },
        });
        setInterimOverdueData(response.data);
      } catch (error) {
        console.error('❌ Interim overdue data failed to load:', error?.message);
        setInterimOverdueData(null);
      } finally {
        setInterimOverdueLoading(false);
      }
    };
    fetchInterimOverdueData();
  }, []);

  return { interimOverdueData, interimOverdueLoading };
}
